export const surveyEndPoint = `survey-analytics/questionnaire`;
export const SurveyResponsesEndPoint = `responses`;
export const ResponsesEndpoint = `responses`;
export const BulkApprovalEndPoint = 'bulk-approval';
export const BulkApprovalUpdateEndPoint = 'bulk-approval-update';
export const nicheEndPoint = `cohorts`;
export const videoRecordingsEndPoint = `video-recordings`;
